<script>
  import { emitter } from '@/main.js';
  export default {
    name: 'PDPYotpoUGC',
    data() {
      return {
        pid: ''
      };
    },
    mounted() {
      emitter.on('pdp-tags-updated', e => {
        const contentWidget = document.getElementById('UGCContent');
        const currentPID = contentWidget.getAttribute('data-product-id');
        if (currentPID !== e.pid) {
          this.pid = e.pid;
          contentWidget.innerHTML = '';
          contentWidget.setAttribute('data-product-id', this.pid);
          setTimeout(() => {
            window.yotpo.refreshWidgets();
            //console.log('refreshed widgets', this.pid);
          }, 250);
        }
      });
    }
  };
</script>

<template>
  <div style="display: none"></div>
</template>
